export default __webpack_public_path__ + "static/media/ABBEY_FALLS.3f924877.jpg";